var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScrollDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.75 33C65.75 51.0873 51.0873 65.75 33 65.75C14.9127 65.75 0.25 51.0873 0.25 33C0.25 14.9127 14.9127 0.25 33 0.25C51.0873 0.25 65.75 14.9127 65.75 33Z",
    fill: "white",
    stroke: "#7D7D7D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4872 9C32.1503 9 31.1991 9.91482 31.1991 11.2361V44.7015L31.4047 50.1393L23.6921 41.7792L17.8563 36.0873C17.4449 35.6808 16.8279 35.4774 16.2109 35.4774C14.9511 35.4774 14 36.4431 14 37.6882C14 38.298 14.2313 38.8317 14.7198 39.3398L31.7904 56.2377C32.2788 56.746 32.8702 57 33.4872 57C34.1298 57 34.7212 56.746 35.2096 56.2377L52.2802 39.3398C52.7687 38.8317 53 38.298 53 37.6882C53 36.4431 52.0489 35.4774 50.7634 35.4774C50.1721 35.4774 49.5551 35.6808 49.1437 36.0873L43.2822 41.7792L35.5953 50.1139L35.8009 44.7015V11.2361C35.8009 9.91482 34.8241 9 33.4872 9Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDown);
export default __webpack_public_path__ + "static/media/scroll-down.250d3b473110eb3d23c10649f7440040.svg";
export { ForwardRef as ReactComponent };